import {Component, h} from "preact";
import {Provider} from "redux-zero/preact";
import store from "../store/store";
import styles from "../index.module.scss"
import {i18nService} from "../services/i18n-service";
import Home from "../routes/home";
import Detail from "../routes/detail";
import {customerService} from "../services/customer-service";
import {NY_Tracker, TrackingEvent} from "../services/tracking-service";
import {Router} from 'preact-router';
import {NY_CountryService} from "../services/country-service";
import {config} from "../config";

export interface State {
  isTranslationLoaded?: boolean;
}

export default class App extends Component<State, any> {

  public static countryCode: string;
  private SAVED_COUNTRY: string = "SAVED_COUNTRY";

  state = {
    isTranslationLoaded: false
  };

  async componentDidMount() {
    App.countryCode =  NY_CountryService.getCountryCode();

    let isTranslationLoaded = await i18nService.initTranslations(App.countryCode);
    this.setState({isTranslationLoaded: isTranslationLoaded});
    this.checkLocalStorage();

    customerService.subscribeForCustomerOnce()
      .then((customer) => {
        if (customer) {
          NY_Tracker.trackClick({
            action: 'userIsLoggedIn',
            category: 'Products'
          } as TrackingEvent);
        } else {
          NY_Tracker.trackClick({
            action: 'userIsAnonymous',
            category: 'Products'
          } as TrackingEvent)
        }
      });
  }

  render() {
    if (!this.state.isTranslationLoaded) {
      return
    }
    return (
        <Provider store={store}>
          <div class={styles['product-client']}>
            <Router>
              <Home path={config.url("/")}/>
              <Detail path={config.url("/detail/:productId/:variantId")} />
            </Router>
          </div>
        </Provider>
    )
  };

  private checkLocalStorage() {
    let countryCode = sessionStorage.getItem(this.SAVED_COUNTRY);
    if (App.countryCode !== countryCode) {
      sessionStorage.removeItem("SCROLL_POSITION");
      sessionStorage.removeItem("QUERY_CONTROLLER");
      sessionStorage.setItem(this.SAVED_COUNTRY, App.countryCode)
    }
  }
}
